import {Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

import {Box} from '@jobseeker/lotus/foundations';
import {Search, SearchOld, SearchPill} from '@jobseeker/lotus/assets/icons';
import {useIsCustomWidth} from '@jobseeker/lotus/hooks';
import {
  getRefTagAndOrigin,
  handleTracking,
  deferTask,
} from '@jobseeker/common-core/utils';
import type {SearchBtnProps} from './types';

const SearchBtn = (props: SearchBtnProps) => {
  const {
    onClick,
    theme,
    calledFrom,
    handleDropClose,
    hideHover,
    isLargeDevice,
    variant = 'icon',
  } = props || {};

  const isSmall = useIsCustomWidth(500);
  const {origin, refText} = getRefTagAndOrigin();

  const handleClick = (event: React.MouseEvent) => {
    deferTask(() => {
      onClick?.(event);
      if (process.env.NEXT_PUBLIC_APP_NAME === 'hirist') {
        handleTracking('jsClickSearchBar', {
          event_category: 'Search',
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Origin: origin,
          Ref: refText,
        });
      }
    });
  };

  if (variant === 'pill') {
    return (
      <Box
        display="flex"
        alignItems="center"
        flexShrink={0}
        width={isLargeDevice ? '260px' : !isSmall ? '126px' : '90px'}
        maxWidth={isLargeDevice ? '260px' : '100%'}
        height={isLargeDevice ? '44px' : '34px'}
        sx={{
          backgroundColor: 'white',
          border: `1px solid ${isLargeDevice ? '#49966E' : '#9DCCB6'}`,
          borderRadius: '50px',
          marginLeft: 0,
          marginRight: isLargeDevice ? theme.spacing(2.5) : theme.spacing(1.5),
          px: isSmall ? theme.spacing(1) : theme.spacing(1.5),
          cursor: 'pointer',
        }}
        data-testid="search_icon"
        onClick={handleClick}
        onMouseEnter={handleDropClose}
      >
        <Image
          src={SearchPill}
          alt={'Search'}
          data-name="navbar-search"
          width={isLargeDevice ? 18 : 16}
          height={isLargeDevice ? 18 : 16}
          objectFit="cover"
          quality={50}
        />
        <Typography
          sx={{
            marginLeft: theme.spacing(1),
            color: '#49966E',
            fontFamily: 'Poppins',
            fontWeight: 500,
            fontSize: isLargeDevice ? '13px' : '12px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {isSmall ? 'Search' : 'Search Jobs'}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      width={calledFrom ? {xxs: '28px', sm: '33px'} : '36px'}
      height={'100%'}
      justifyContent={'center'}
      sx={{
        color: 'secondary.main',
        marginRight: hideHover
          ? {xxs: 0, md: theme.spacing(2)}
          : theme.spacing(1.125),
        ':hover': hideHover
          ? {}
          : {
              background: 'white',
              boxShadow: '6px 6px 12px 2px rgba(41, 41, 41, 0.04)',
              borderRadius: '20px',
              border: '0.10px rgba(126, 126, 126, 0.40) solid',
            },
        cursor: 'pointer',
      }}
      data-testid="search_icon"
      onClick={handleClick}
      onMouseEnter={handleDropClose}
    >
      <Image
        src={hideHover ? SearchOld : Search}
        alt={'Search'}
        data-name="navbar-search"
        width={hideHover ? 21 : calledFrom ? 18 : 20}
        height={hideHover ? 21 : calledFrom ? 18 : 20}
        objectFit="cover"
        quality={50}
        style={{
          margin: theme.spacing(0.875),
        }}
      />
    </Box>
  );
};

export default SearchBtn;
